/* src/app/shared/components/list-table/list-table.component.css */
:host ::ng-deep .p-icon-field-left .p-input-icon:first-of-type {
  left: 48.75rem;
  color: #71717a;
  top: 9px;
}
a {
  color: blue;
}
::ng-deep a:focus-visible {
  outline: var(--focus-outline);
  outline-offset: 2px;
  display: inline-block;
}
::ng-deep ppl-list-table span:focus-visible {
  outline: var(--focus-outline);
  outline-offset: 2px;
  display: inline-block;
}
.actGRP {
  display: flex;
  flex-direction: row;
  gap: 8px;
}
.ico {
  filter: invert(0.75);
}
.category-cell {
  border-left: 4px solid #d1d5db;
}
.category-cell--original,
.category-cell--claim {
  border-left-color: #14b8a6;
}
.category-cell--payment {
  border-left-color: #22c55e;
}
.category-cell--voidance {
  border-left-color: #ef4444;
}
.category-cell--adjustment {
  border-left-color: #8b5cf6;
}
.category-cell--reversal {
  border-left-color: #f59e0b;
}
.category-cell--cdr {
  border-left-color: #1890ff;
}
.category-cell--spr {
  border-left-color: #22c55e;
}
.category-cell--manual {
  border-left-color: #8b5cf6;
}
.category-cell--writeoff {
  border-left-color: #6b7676;
}
.category-badge {
  display: inline-flex;
  align-items: center;
  padding: 5px 16px;
  border-radius: 999px;
  border: 1px solid transparent;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  white-space: nowrap;
}
.category-badge--original,
.category-badge--claim {
  color: #0d9488;
  background: #ccfbf1;
  border-color: #99f6e4;
}
.category-badge--payment {
  color: #16a34a;
  background: #dcfce7;
  border-color: #bbf7d0;
}
.category-badge--voidance {
  color: #dc2626;
  background: #fee2e2;
  border-color: #fecaca;
}
.category-badge--adjustment {
  color: #7c3aed;
  background: #ede9fe;
  border-color: #ddd6fe;
}
.category-badge--reversal {
  color: #b45309;
  background: #fef3c7;
  border-color: #fde68a;
}
.category-badge--cdr {
  color: #1890ff;
  background: #eff6ff;
  border-color: #bfdbfe;
}
.category-badge--spr {
  color: #16a34a;
  background: #dcfce7;
  border-color: #bbf7d0;
}
.category-badge--manual {
  color: #5b46a8;
  background: #eeecfd;
  border-color: #cdc6f2;
}
.category-badge--writeoff {
  color: #454545;
  background: #f1f2f5;
  border-color: #d9d9d9;
}
.net-ledger-event {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.net-ledger-event__title {
  font-weight: 700;
  color: #1f2a2a;
}
.net-ledger-event__note {
  font-size: 0.8rem;
  color: #6b7676;
}
.deposit-pill {
  display: inline-flex;
  align-items: center;
  padding: 4px 14px;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.4px;
}
.deposit-pill--yes {
  background: #dcfce7;
  color: #16a34a;
}
.deposit-pill--no {
  background: #fee2e2;
  color: #dc2626;
}
.util-cell {
  display: inline-block;
  min-width: 72px;
}
.util-cell__pct {
  display: block;
  font-weight: 600;
  font-size: 0.929rem;
}
.util-cell__bar {
  display: block;
  height: 4px;
  margin-top: 4px;
  border-radius: 2px;
  background: #eceef2;
  overflow: hidden;
}
.util-cell__bar i {
  display: block;
  height: 100%;
  border-radius: 2px;
  background: #01796f;
}
.util-cell--full .util-cell__pct {
  color: #1e8a4c;
}
.util-cell--full .util-cell__bar i {
  background: #1e8a4c;
}
.util-cell--none .util-cell__pct {
  color: #454545;
}
.advance-pill {
  display: inline-flex;
  align-items: center;
  padding: 4px 14px;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.4px;
}
.advance-pill--yes {
  background: #eeecfd;
  color: #5b46a8;
}
.advance-pill--no {
  background: #f1f2f5;
  color: #454545;
}
.net-ledger-claim--current {
  font-weight: 700;
  color: #1f2a2a;
}
.net-ledger-claim-link {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  font-family:
    "Cascadia Code",
    "Consolas",
    "Courier New",
    monospace;
  font-size: 0.786rem;
  font-weight: 600;
  color: #01796f;
  text-decoration: underline;
  cursor: pointer;
}
.net-ledger-claim-link:hover {
  color: #004c4a;
}
.credit-cell--value {
  color: #16a34a;
  font-weight: 700;
}
.ar-amount--zero,
.ar-amount--positive {
  text-align: center;
  font-weight: 700;
}
.ar-amount--zero {
  color: #1e8a4c;
}
.ar-amount--positive {
  color: #c0392b;
}
.status-pill {
  display: inline-flex;
  align-items: center;
  padding: 5px 14px;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 700;
  white-space: nowrap;
}
.status-pill--paid {
  background: #e8f6ed;
  color: #1e8a4c;
}
.status-pill--pending {
  background: #fdf3d8;
  color: #8a6d1e;
}
.status-pill--resubmitted {
  background: #fdeceb;
  color: #c0392b;
}
.status-pill--partial {
  background: #eff6ff;
  color: #1890ff;
}
.status-pill--denied {
  background: #fdeceb;
  color: #c0392b;
}
.status-pill--default {
  background: #f1f2f5;
  color: #6b7676;
}
.ico:hover {
  cursor: pointer;
}
img {
  filter: invert(0.75);
}
.table-header-action-container {
  display: flex;
  position: relative;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
}
.header-text {
  font-weight: 600;
  font-size: 1.071rem;
}
.condition-dropdown-container {
  display: flex;
  padding: 12px;
  padding-bottom: 17px;
  margin-bottom: 12px;
}
.condition-dropdown-container label {
  position: relative;
  top: 3px;
  margin-right: 10px;
  font-family: outfit !important;
  font-size: 1rem;
}
.sortBy {
  padding: 12px;
  margin-bottom: 12px;
  display: grid;
  grid-template-columns: 48% 50%;
  grid-gap: 12px;
}
.global-search {
  border: 1px solid #cdc7c7;
  padding-left: 16px;
  padding-top: 5px;
  padding-bottom: 5px;
  border-radius: 8px;
  width: 100%;
}
::ng-deep .p-overlaypanel-content {
  margin-top: 6px;
}
::ng-deep .p-dropdown {
  width: 100%;
  font-size: 1rem;
  font-family: outfit;
}
::ng-deep .p-dropdown-item {
  font-size: small;
  font-family: outfit;
}
::ng-deep .p-dropdown-label {
  padding: 3px 0px 6px 9px;
  border-right: 1px solid #cdcdd0;
  border-radius: 0px;
  font-size: small;
}
.search-input {
  border: 1px solid #cdc7c7;
  padding-left: 16px;
  border-radius: 8px;
  font-size: 1rem;
  margin-right: 4px;
}
.filter-btn {
  padding: 3px 8px 3px 8px !important;
}
.filter-panel {
  width: 100%;
}
.filter-text {
  font-weight: 400 !important;
  font-size: 0.929rem !important;
  margin-right: 4px;
}
.filter-manger {
  padding: 8px;
  display: grid;
  grid-template-columns: 31% 21% 31% auto auto;
  gap: 10px;
  margin-bottom: 12px;
}
.filter-action-btn {
  display: flex;
  justify-content: end;
  margin-top: 18px;
}
.filter-error {
  display: flex;
  justify-content: center;
  margin-top: 18px;
  font-size: 1rem;
}
.filter-action-btn button {
  padding-left: 46px;
  border: 1px solid #cdcdd0;
  border-radius: 5px;
  padding-right: 45px;
  cursor: pointer;
  background-color: white;
}
.primary-bgclr {
  background-color: #3b82f6 !important;
  color: white;
}
.success-btn-color {
  background-color: rgb(81, 189, 81) !important;
  color: white;
  border: none;
  font-weight: 500;
  padding: 5px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.success-btn-color:hover {
  opacity: 0.8;
}
.danger-btn-color:hover {
  opacity: 0.8;
}
.hammer-btn {
  cursor: pointer;
  background-color: #e2e2e2 !important;
  padding: 6px 8px 8px 8px;
  border-radius: 4px;
  position: relative;
  top: -7px;
  right: -9px;
  margin-right: 8px;
}
.drop-btn {
  cursor: pointer;
  padding: 7px;
  border-radius: 4px;
  margin-left: 0;
  border: 1px solid #cdc7c7;
  font-size: 1rem;
}
.global-search::placeholder {
  color: black;
}
.form-group label {
  display: block;
  margin-bottom: 6px;
}
.form-group textarea {
  width: 100%;
  box-sizing: border-box;
}
::ng-deep .ant-modal-header,
::ng-deep .ant-modal-footer {
  background-color: #cff1f04d;
}
.delete-btn {
  cursor: pointer;
  background-color: #e2e2e2 !important;
  color: black !important;
  padding: 4px;
  border: none !important;
  outline: none !important;
}
.delete-btn:focus {
  box-shadow: none !important;
}
.danger-btn-color {
  background-color: #f06060 !important;
  color: white;
  border: none;
  font-weight: 500;
  padding: 5px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.secondary-btn-color {
  background-color: #ffffff !important;
  color: rgb(0, 0, 0);
  border: 1px solid #e2e2e2;
  font-weight: 500;
  padding: 5px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.primary-btn-color {
  background: #1890ff !important;
  color: white;
  border: none;
  font-weight: 500;
  padding: 3px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
}
.primary-btn-color_1 {
  background: #1890ff !important;
  color: white;
  border: none;
  font-weight: 500;
  padding: 3px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
}
.disabled-btn {
  cursor: not-allowed !important;
  color: rgb(165, 157, 157) !important;
  background: white !important;
}
.row-buttons {
  display: flex;
  align-items: center;
  font-size: small;
  position: absolute;
  right: 0;
}
.row-buttons-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.row-buttons-container h4 {
  margin: 0;
}
.filter-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.row-btns {
  padding: 0 0 0 10px;
}
::ng-deep .p-button-icon-only {
  background: #1890ff;
  color: white;
  padding: 4px;
}
:host ::ng-deep .p-paginator {
  padding-top: 25px !important;
  padding-right: 0px !important;
  justify-content: end;
  color: #6e6e77;
}
.list-table-component td {
  font-size: 0.929rem;
}
td {
  font-size: 0.929rem;
  padding: 8px 3px;
}
.prospective {
  padding: 0.75rem 1.5rem;
}
th {
  color: #000000d9 !important;
  font-size: 0.929rem;
  font-weight: 600;
  padding-bottom: 0px;
}
:host ::ng-deep p-inputicon {
  padding-top: 10px !important;
}
:host ::ng-deep .p-checkbox .p-highlight {
  background: #1890ff !important;
  border: 0px;
  border-radius: 0px;
}
:host ::ng-deep .p-datatable .p-datatable-tbody > tr.p-highlight {
  background: #fafafa !important;
  color: #000000d9 !important;
  font-weight: 100;
}
.filter-item {
  display: flex;
  justify-content: space-between;
}
.filter-item div {
  display: flex;
}
.filter-item {
  border-right: 1px solid rgba(0, 0, 0, .06);
}
.last-th {
  border: none;
}
::ng-deep .ant-modal-title {
  font-weight: 600;
}
.check-box {
  padding-left: 24px !important;
}
::ng-deep .p-button {
  background: #1677ff !important;
  color: white !important;
  font-size: 0.929rem !important;
  font-family: outfit !important;
}
::ng-deep .p-datatable-header {
  background-color: white !important;
  padding: 0 0 5px 0;
  border: none;
}
.csv-btn {
  padding: 5px 8px;
}
:host ::ng-deep .p-overlaypanel:after,
.p-overlaypanel:before {
  border: none !important;
}
.custom-search-btn {
  cursor: pointer;
  padding: 6px 8px 8px 8px;
  border-radius: 4px;
  position: relative;
  top: -7px;
  right: -9px;
  margin-right: 8px;
}
.action-item > * {
  margin-right: 0.75rem;
  padding-left: 20px;
}
.action-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 8px;
  box-sizing: border-box;
}
.table-data-first-column {
  cursor: pointer;
  color: blue;
}
.table-data-first-column:hover {
  color: hotpink;
}
.table-data-first-column:active {
  color: blue;
}
.line-item-table {
  width: 100% !important;
}
.hyperlink {
  cursor: pointer;
}
button:focus-visible {
  outline: 3px solid rgba(0, 0, 255, 1) !important;
  outline-offset: 2px;
}
.bold-text {
  font-weight: 800;
}
.expand-row-icon-btn {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
}
/*# sourceMappingURL=list-table.component-7W7RO5X3.css.map */
